/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Staple_On_ListInputs */

const en_staple_on_list = /** @type {(inputs: Staple_On_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On the shopping list`)
};

const de_staple_on_list = /** @type {(inputs: Staple_On_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf der Einkaufsliste`)
};

/**
* | output |
* | --- |
* | "On the shopping list" |
*
* @param {Staple_On_ListInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const staple_on_list = /** @type {((inputs?: Staple_On_ListInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Staple_On_ListInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_staple_on_list(inputs)
	return en_staple_on_list(inputs)
});